import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { Suspense } from "react";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/pelajaran";
var post = "/pelajaran";
export const actGetDataPelajaran = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_PELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PELAJARAN",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_PELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataPelajaran = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_PELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_PELAJARAN", open: false }));
          return dispatch(actGetDataPelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataPelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_PELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson has been update");
          dispatch(__openModal({ modal: "MODAL_EDIT_PELAJARAN", open: false }));
          return dispatch(actGetDataPelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataPelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_PELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PELAJARAN",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_PELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataPelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_PELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson has been deleted");
          return dispatch(actGetDataPelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_PELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PELAJARAN",
          message: "Network error..",
        });
      });
  };
};
